<template>
  <order-body :isOk="false" :codeStatus="800" :pageText="'orderRtc'">
  </order-body>
</template>

<script>
import orderBody from "_my/order-body";

export default {
  name: "orderRtc",
  components: {
    orderBody,
  },
};
</script>